var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69333 15.4007L7.74 15.4273L7.75867 15.438C7.83269 15.478 7.91552 15.499 7.99967 15.499C8.08382 15.499 8.16664 15.478 8.24067 15.438L8.25933 15.428L8.30667 15.4007C8.56741 15.2461 8.82184 15.081 9.06933 14.906C9.71005 14.4537 10.3087 13.9445 10.858 13.3847C12.154 12.058 13.5 10.0647 13.5 7.5C13.5 6.04131 12.9205 4.64236 11.8891 3.61091C10.8576 2.57946 9.45869 2 8 2C6.54131 2 5.14236 2.57946 4.11091 3.61091C3.07946 4.64236 2.5 6.04131 2.5 7.5C2.5 10.064 3.84667 12.058 5.142 13.3847C5.6911 13.9445 6.28952 14.4536 6.93 14.906C7.17771 15.0811 7.43236 15.2461 7.69333 15.4007ZM8 9.5C8.53043 9.5 9.03914 9.28929 9.41421 8.91421C9.78929 8.53914 10 8.03043 10 7.5C10 6.96957 9.78929 6.46086 9.41421 6.08579C9.03914 5.71071 8.53043 5.5 8 5.5C7.46957 5.5 6.96086 5.71071 6.58579 6.08579C6.21071 6.46086 6 6.96957 6 7.5C6 8.03043 6.21071 8.53914 6.58579 8.91421C6.96086 9.28929 7.46957 9.5 8 9.5Z",
    fill: "#CF072C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a4e871fd10fbd6af7b1cb65cae50396e.svg";
export { ForwardRef as ReactComponent };